<template>
  <div class="notification-detail-container" v-rect-loading="loading">
    <div class="title-container">
      {{ $t(`${i18nPrefix}.label.notification`) }}
    </div>
    <div class="detail-info-container">
      <div class="title-info-container">
        <div class="title">{{ notificationData.title }}</div>
        <div class="time">{{ createdTime }}</div>
      </div>
      <div class="content" v-html="notificationData.content"></div>
    </div>
    <div class="btn-container">
      <el-button class="return-button" type="primary" @click="handelBack">{{ $t(`${i18nPrefix}.button.return`) }}</el-button>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  components: {
  },
  data () {
    return {
      i18nPrefix: 'admin.notification',
      loading: false,
      notificationData: {}
    }
  },
  computed: {
    notificationId () {
      return this.$route.params.notificationId
    },
    createdTime () {
      return moment(this.notificationData.created_time).format('YYYY-MM-DD')
    }
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions('notification', ['getNotificationDetail']),
    async initData () {
      this.loading = true
      try {
        const resp = await this.getNotificationDetail(this.notificationId)
        if (resp) {
          this.notificationData = resp
        }
      } finally {
        this.loading = false
      }
    },
    handelBack () {
      this.$router.push('/v-admin/notification/list/')
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-detail-container {
  width: 100%;
  min-height: 100%;
  background: #FFFFFF;
  min-width: 1320px;
  padding: 20px;
  overflow: auto;

  .title-container {
    line-height: 40px;
    text-align: center;
    font-size: 24px;
    padding-bottom: 10px;
    margin: 0 auto 20px;
    width: 900px;
    border-bottom: 2px solid #cccccc;
  }

  .detail-info-container {
    width: 900px;
    border-top: 2px solid #cccccc;
    background-color: #f9f9f9;
    margin: auto;
    padding: 10px 24px;
    margin-bottom: 30px;
    font-size: 14px;
    border: 1px solid #ddd;
    overflow: hidden;

    .title-info-container {
      > div {
        display: inline-block;
      }

      .title {
        width: 85%;
        color: #0096cc;
        font-size: 16px;
      }

      .time {
        width: 15%;
        text-align: right;
      }
    }

    .content {
      margin-top: 20px;
      ::v-deep {
        img {
          max-width: 100%;
        }
      }
    }
  }

  .btn-container {
    width: 900px;
    margin: auto;
    text-align: right;
  }
}
</style>
